import type { Id } from '@e-socna/data-layer';

import type { MissionQuotationPage_OneQuotation } from '../../../pages/MissionQuotation/hooks/useFindOneQuotationQuery.hook';
import type { MissionQuotationPage_QuotationInfo } from '../../../pages/MissionQuotation/fragments/quotation-info.fragment';

export enum QuotationContextStatus {
  Loading = 'loading',
  NotInitialized = 'notInitialized',
  Ready = 'ready',
  Error = 'error',
}

interface QuotationContextLoading {
  readonly status: QuotationContextStatus.Loading;
  readonly missionQuotationId: undefined;
  readonly missionQuotation: undefined;
  readonly missionQuotationInfo: undefined;
}

interface QuotationContextNotInitialized {
  readonly status: QuotationContextStatus.NotInitialized;
  readonly missionQuotationId: undefined;
  readonly missionQuotation: undefined;
  readonly missionQuotationInfo: undefined;
}

interface QuotationContextReady {
  readonly status: QuotationContextStatus.Ready;
  readonly missionQuotationId: Id;
  readonly missionQuotation: MissionQuotationPage_OneQuotation;
  readonly missionQuotationInfo: MissionQuotationPage_QuotationInfo;
}

interface QuotationContextError {
  readonly status: QuotationContextStatus.Error;
  readonly missionQuotationId: undefined;
  readonly missionQuotation: undefined;
  readonly missionQuotationInfo: undefined;
}

export type QuotationContextData =
  | QuotationContextLoading
  | QuotationContextNotInitialized
  | QuotationContextReady
  | QuotationContextError;
